import { BannerTypes } from './IGoogleTag';

export class PresentationBannerInfo {
	public constructor(
		public readonly containerId: string,
		public readonly cssClass: string,
		public readonly type: BannerTypes,
	) {}
}
